
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ApolloProvider } from '@apollo/client';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import client from './components/apploClient';
import { Provider } from 'react-redux';
import store from './components/store';
import './components/amplify/aws-config';
import { ProSidebarProvider } from 'react-pro-sidebar';

import { Amplify, Auth } from 'aws-amplify';
import awsconfig from './aws-exports';
Amplify.configure(awsconfig);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ProSidebarProvider>
      <ApolloProvider client={client}>
          <Provider store={store}>
            <App />
          </Provider>
      </ApolloProvider>
    </ProSidebarProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
